import React from "react";
import { FeatherDownload, FeatherPlus, FeatherSearch } from "@subframe/core";
import { Badge } from "../../../../ui/components/Badge";
import { Button } from "../../../../ui/components/Button";
import { TextField } from "../../../../ui/components/TextField";
import { DateRangeFilter } from "../../../../shared/presentation/components/DateRangeFilter";
import { DateRangeValue } from "../../../../shared/presentation/utils/dateRangeFilters";

interface CashBankHeaderProps {
  dateRange: DateRangeValue;
  onDateRangeChange: (value: DateRangeValue) => void;
  canAddBankAccount: boolean;
  onAddBankAccount: () => void;
  lockedAccountMessage?: string | null;
}

export const CashBankHeader: React.FC<CashBankHeaderProps> = ({
  dateRange,
  onDateRangeChange,
  canAddBankAccount,
  onAddBankAccount,
  lockedAccountMessage,
}) => (
  <div className="flex w-full flex-wrap items-center gap-2 mobile:flex-col mobile:flex-nowrap mobile:items-start">
    <div className="flex grow shrink-0 basis-0 flex-col items-start gap-1">
      <div className="flex items-center gap-2">
        <span className="text-heading-2 font-heading-2 text-default-font">
          Cash &amp; Bank (Reconciliation)
        </span>
        <Badge className="hidden">Acme Corporation</Badge>
      </div>
      <span className="text-body font-body text-subtext-color">
        Match and reconcile your transactions with invoices and bills
      </span>
    </div>
    <div className="flex flex-wrap items-center gap-2">
      <TextField
        className="hidden h-auto w-64 flex-none"
        variant="filled"
        label=""
        helpText=""
        icon={<FeatherSearch />}
      >
        <TextField.Input
          placeholder="Search all transactions..."
          value=""
          onChange={() => {}}
        />
      </TextField>
      <DateRangeFilter value={dateRange} onChange={onDateRangeChange} />
      <Button
        className="hidden"
        variant="neutral-secondary"
        icon={<FeatherDownload />}
        onClick={() => {}}
      >
        Export
      </Button>
      {canAddBankAccount && (
        <Button icon={<FeatherPlus />} onClick={onAddBankAccount}>
          Add account
        </Button>
      )}
    </div>
    {lockedAccountMessage && (
      <div className="flex w-full items-center gap-2 rounded-md border border-solid border-warning-200 bg-warning-50 px-3 py-2">
        <span className="text-caption-bold font-caption-bold text-warning-700">
          {lockedAccountMessage}
        </span>
      </div>
    )}
  </div>
);
